import { QuotePageA } from './QuotePageA/QuotePageA';
import { QuotePageRadio } from './QuotePageRadio/QuotePageRadio';
import { store } from '../../store/store';
import { QuotePageVariant, isQuotePageVariant } from '@domgen/shared/enums/featureFlags';

export function QuotePage() {
  const variant = store.get().context.gaEventData?.experimentVariant;

  if (!isQuotePageVariant(variant)) {
    return <QuotePageA />;
  }

  switch (variant) {
    case QuotePageVariant.RADIO:
      return <QuotePageRadio />;
    case QuotePageVariant.CONTROL:
      return <QuotePageA />;
  }
}
